<template>
  <span class="renderer">
    <router-link
      v-if="canRead"
      :to="link"
      :class="classNames"
    >
      {{ object.name }}
    </router-link>
    <span
      v-if="!canRead"
      :class="classNames"
    >
      {{ object.name }}
    </span>
  </span>
</template>

<script>
import Utils from "@/services/utils.js";

export default {
  name: "NameTableRenderer",
  computed: {
    link() {
      return "/configurations/watchmen/" + this.object.id;
    },
    canRead() {
      return Utils.can("beepiz-read-watchmen");
    },
    classNames() {
      return {
        "font-weight-bold": true,
        "underline": true,
        "text-danger": this.object.system_name,
        "font-italic": this.object.system_name,
      };
    },
  },
  props: ["object"],
};
</script>
